import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Schema } from './create/components/team-form.schema';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateTeamMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ payload }: { payload: Schema }) =>
      SSF.api.teamsCreate({ ...payload, division: payload.division[1], club: payload.club[1] }),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useUpdateTeamMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: Schema }) =>
      SSF.api.teamsUpdate(id, {
        ...payload,
        division: payload.division[1],
        club: payload.club[1],
      }),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteTeamMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.teamsDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
